/**
 * We need some global css classes on html element for
 * global styling change based on params in the URL
 */
export default function applyGlobalCssStyling() {
  showRect();
  hideTopbar();
}

////////

/**
 * Applies colour to replica articles layers to make them visible
 */
function showRect() {
  if (window.location.search.indexOf("showrects") !== -1) {
    document.documentElement.classList.add("show-rect");
  }
}

/**
 * Hides top bar
 */
function hideTopbar() {
  if (window.location.search.indexOf("hidetopbar") !== -1) {
    document.documentElement.classList.add("hide-topbar");
  }
}



// WEBPACK FOOTER //
// ./src/common/utilities/globalStylingModifier.js